module.exports = __webpack_public_path__ + "img/combined_logo_upscaled.9e4320fa.png";